import clsx from "clsx";
import Icon from "@/components/elements/Icon";
import Image from "@/components/elements/Image";
import LinkComponent from "@/components/elements/LinkComponent";

import * as styles from "./styles.module.scss";

export function RichTextImageInfographic({
  document,
  image,
  thumbnail,
}: Partial<ImageInfographicComponent>) {
  const isThumbnailDisplayed = !!thumbnail?.image;
  const isImageDisplayed = !!image?.image;
  const isGif = !!image?.image && image.image.endsWith(".gif");

  return (
    <div className={clsx(styles.container, isGif && styles.customGif)}>
      {/* thumbnail */}
      {isThumbnailDisplayed ? <Image data={thumbnail.image} fluid /> : null}

      {/* image */}
      {!isThumbnailDisplayed && isImageDisplayed ? (
        <Image data={image.image} fluid />
      ) : null}

      <div className={styles.links}>
        {/* pdf download */}
        {document?.filename ? (
          <LinkComponent url={document.filename} type="external">
            Download PDF
            <Icon name="arrowUpRight" />
          </LinkComponent>
        ) : null}

        {/* infographic download */}
        {isImageDisplayed ? (
          <LinkComponent url={image.image} type="external">
            Download infographic
            <Icon name="arrowUpRight" />
          </LinkComponent>
        ) : null}
      </div>
    </div>
  );
}
